import RadioGroup from 'ext-ui/components/RadioGroup/RadioGroup'
import React from 'react'
import Box from 'src/components/Box/Box'
import TextInputField, {
  TextInputFieldDesigns,
} from 'src/components/TextInputField/TextInputField'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { BillPayRecipient } from 'src/components/VirtualCardForm/VirtualCardForm'
import { useTranslate } from 'src/localization/Trns'
import { FormProps } from 'src/types'
import { css } from 'styled-components'

interface VendorNameInputBoxProps {
  id?: string
  className?: string
  billPayRecipientProps: FormProps<BillPayRecipient>
  vendorEmailProps: FormProps<string>
  static?: boolean
}

const BillPayRecipientInputBox: React.FC<VendorNameInputBoxProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const tooltip = (
    <Tooltip
      openLeft={false}
      css={css`
        height: auto;
        display: inline-block;
        vertical-align: middle;
      `}
    >
      <p>
        {translate(
          'Once created, the card will be visible in the Bill Pay section',
        )}
      </p>
    </Tooltip>
  )

  const vendorEmailInput = (
    <TextInputField
      css={css`
        margin-top: 12px;
      `}
      id={'vendorEmailTextInputField'}
      fieldLabel={translate('Vendor Email')}
      showUpdates={props.vendorEmailProps.showUpdates}
      value={props.vendorEmailProps.value}
      baseValue={props.vendorEmailProps.baseValue}
      errors={props.vendorEmailProps.errors}
      onChange={props.vendorEmailProps.onChange}
      placeholder={
        props.vendorEmailProps.placeHolder ??
        translate('Enter ${fieldLabel}', {
          fieldLabel: translate('email'),
        })
      }
      design={TextInputFieldDesigns.New}
      disabled={props.static}
      characterLimit={255}
      hideCharacterLimitCount
    />
  )

  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <RadioGroup
        name="recipient"
        label={translate('Where should the card be sent?')}
        labelTooltip={tooltip}
        value={props.billPayRecipientProps.value?.toString() ?? null}
        onChange={(val) => props.billPayRecipientProps.onChange(Number(val))}
        errors={props.billPayRecipientProps.errors}
        options={[
          {
            value: BillPayRecipient.Vendor.toString(),
            title: translate('The Vendor'),
            description: translate(
              'Securely send the card details via email directly to the vendor for invoice payment',
            ),
            extraSelectedContent: vendorEmailInput,
            testId: 'radioButton-vendor',
          },
          {
            value: BillPayRecipient.Myself.toString(),
            title: translate('Myself'),
            description: translate(
              'Send the card to myself so that I can complete the invoice payment',
            ),
            testId: 'radioButton-self',
          },
        ]}
      />
    </Box>
  )
}

export default BillPayRecipientInputBox
